import { render, staticRenderFns } from "./EntryList_SecondChance.vue?vue&type=template&id=55b44edb&scoped=true"
import script from "./EntryList_SecondChance.vue?vue&type=script&lang=js"
export * from "./EntryList_SecondChance.vue?vue&type=script&lang=js"
import style0 from "./EntryList_SecondChance.vue?vue&type=style&index=0&id=55b44edb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b44edb",
  null
  
)

export default component.exports